<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        @input="init"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="value"
                :rules="field.rules"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                @blur="init"
            ></v-text-field>
        </template>
        <v-date-picker v-model="date" @input="selectDate"></v-date-picker>
    </v-menu>
</template>

<script>

export default {
    props: {
        value: String,
        field: Object,
    },
    data: () => ({
        menu: false,
        date: null,
    }),
    methods: {
        init() {
            this.date = this.value;
        },
        selectDate(e) {
            this.menu = false;
            this.$emit('input', e);
        },
    },
};
</script>

<style>
</style>
